import { Group } from '@mantine/core';
import { AdminSettingsButton } from '~portal/components/AdminSettingsButton';
import { ColorSchemeToggle } from '~portal/components/ColorSchemeToggle';
import { Cmp } from '~portal/lib';

/**
 * @desc The scheme control and (administrators only) the admin cog, as one compact row directly
 * above the account block. Not in the Figma file — kept visible by operator decision so neither
 * setting moves behind a menu (docs/figma-deviations.md).
 */
export const NavSettings: Cmp = function () {
  return (
    <Group gap="xs" wrap="nowrap" px="xs">
      <ColorSchemeToggle />
      <AdminSettingsButton />
    </Group>
  );
};
